<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">Carga base</h1>
    </div>

    <wz-card>
      <div class="flex justify-between items-center mb-4">
        <p class="text-muted mb-0">Cargue los datos de la planilla desde un archivo Excel (.xlsx)</p>
        <wz-button variant="light" @click="downloadTemplate">
          <i class="ri-download-line mr-1"></i>Descargar plantilla
        </wz-button>
      </div>

      <form @submit.prevent="save" novalidate>
        <wz-alert variant="light" icon="ri-error-warning-line">
          Seleccione el periodo para poder cargar su archivo XLSX.
        </wz-alert>

        <div class="flex flex-wrap -mx-2 mt-4">
          <div class="w-full md:w-1/2 px-2 mb-3">
            <wz-select
              id="period"
              label="Periodo"
              required
              v-model="form.period"
              :items="periods.map(p => ({ key: p, label: p }))"
              default-option="Seleccione periodo"
              :error="$v.form.period.$error && !$v.form.period.required ? 'Periodo es requerido' : ''"
            />
          </div>

          <div class="w-full md:w-1/2 px-2 mb-3">
            <wz-select
              id="type"
              label="Tipo"
              required
              v-model="form.type"
              :items="typeList"
              default-option="Seleccione tipo"
              :error="$v.form.type.$error && !$v.form.type.required ? 'Tipo es requerido' : ''"
            />
          </div>

          <div class="w-full md:w-1/2 px-2 mb-3">
            <wz-input
              id="name"
              label="Nombre de Planilla"
              required
              placeholder="Ingresar nombre de Planilla"
              v-model="form.name"
              :error="$v.form.name.$error && !$v.form.name.required ? 'Nombre de Planilla es requerido' : ''"
            />
          </div>

          <div class="w-full md:w-1/2 px-2 mb-3">
            <label class="wz-form-label">Carga de archivo <span class="wz-form-required">*</span></label>
            <wz-file-input
              id-file="file"
              :accept-file="['.xlsx']"
              @onChange="onFileChange"
            />
            <span v-if="$v.form.file.$error && !$v.form.file.required" class="wz-form-error-msg">
              <i class="ri-error-warning-line"></i>El archivo es requerido
            </span>
          </div>
        </div>

        <div class="flex justify-end gap-2 mt-3">
          <wz-button variant="outline" type="button" @click="$router.push({ name: 'payroll-base-batch' })">Cancelar</wz-button>
          <wz-button variant="primary" type="submit">Procesar</wz-button>
        </div>

        <div class="mt-3" v-if="errors.length > 0">
          <wz-alert variant="danger" icon="ri-error-warning-line">
            <strong>Errores: {{ errors.length }}</strong>
            <ul class="m-0 pl-3">
              <li v-for="(e, i) in errors" :key="i">{{ e }}</li>
            </ul>
          </wz-alert>
        </div>
      </form>
    </wz-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import fileDownload from "js-file-download";

import { Alert } from "@wizepe/wizeui"
import { Util } from "@wizepe/wizeui"
import { Constants as LocalConstants } from "@/core/utils";
import { Util as Utils } from "@wizepe/wizeui";
import { PayrollBatchService } from "@/core/services";

export default {
  name: "PayrollBatchUpload",
  data() {
    return {
      errors: [],
      periods: [],
      typeList: [
        LocalConstants.PayrollTypes.OPERATORS,
        LocalConstants.PayrollTypes.ADMINISTRATORS,
      ],
      form: {
        period: null,
        name: null,
        type: null,
        file: null,
      },
    };
  },
  validations: {
    form: {
      period: { required },
      file:   { required },
      name:   { required },
      type:   { required },
    },
  },
  methods: {
    async downloadTemplate() {
      try {
        await this.$store.dispatch("app/loading", true);
        const response = await PayrollBatchService.download();
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        console.error(error);
        Alert.error(error.errors ? error.errors.message : 'Error al descargar la plantilla');
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$error) return;

      await this.$store.dispatch("app/loading", true);
      this.errors = [];
      try {
        const resp = await PayrollBatchService.uploadBatch({ ...this.form });
        if (resp.payload.messages && resp.payload.messages.length > 0) {
          this.errors = resp.payload.messages;
          return;
        }
        Alert.success("Se cargó la base correctamente");
        this.$router.push({ name: "payroll-base-batch" });
      } catch (e) {
        this.errors = [];
        if (e.errors && e.errors.message) this.errors.push(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    onFileChange(files) {
      this.$v.form.file.$reset();
      this.form.file = Array.isArray(files) ? files[0] : files;
    },
  },
  async created() {
    this.periods = Utils.generatePeriods();
  },
};
</script>

<style lang="stylus" scoped></style>
